// extracted by mini-css-extract-plugin
module.exports = {"title":"UserLogin__title","borderButton":"UserLogin__borderButton","paymentPage":"UserLogin__paymentPage","paymentForm":"UserLogin__paymentForm"};